import { RiEyeFill } from '@remixicon/react'
import { useState } from 'react'

import { useItemMutation } from '@/api/items/items'
import type { Detail } from '@/api/orders/orders-types'
import { Toggle } from '@/components/ui/toggle'

interface ViewToggleProps {
  detail: Detail
}

export const ViewToggle = ({ detail }: ViewToggleProps) => {
  const [isWatched, setIsWatched] = useState(detail?.item?.is_watched ?? false)
  const { handleMutation } = useItemMutation({ action: 'is_watched' })

  const handleWatchedPressed = () => {
    setIsWatched(!isWatched)
    handleMutation({
      detail,
      payload: {
        is_watched: !isWatched
      }
    })
  }
  return (
    <Toggle
      onClick={(e) => e.stopPropagation()}
      pressed={isWatched}
      onPressedChange={handleWatchedPressed}
      className='h-6 w-9 rounded-full'
      disabled={!Object.keys(detail?.standard_times ?? {}).length}
      variant='secondary'
    >
      <RiEyeFill />
    </Toggle>
  )
}
